<template>
  <div>
    <header>
      <section class="header__container d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img
            v-if="showBackButton"
            src="@/assets/images/icons/bread_crumb.svg"
            @click="goBack(breadcrumbItems)"
            :class="{
              hide_go_back:
                breadcrumbItems.length < 1 &&
                !(breadcrumbItems[0]?.customGoBack && $route?.query?.clientID),
              '-translate-scale-1': isLangRtl,
            }"
          />
          <b-breadcrumb
            :class="notMobile ? '' : 'small-size'"
            :items="breadcrumbItems"
            id="breadcrumb-item"
          ></b-breadcrumb>
        </div>
        <div class="position-relative">
          <div class="d-flex align-items-center">
            <div style="position: relative">
              <div class="bell-icon" v-if="notMobile">
                <img
                  :src="require(`@/assets/images/icons/bell.svg`)"
                  alt="Drivers"
                  @click="toggleShowNotificationList"
                  v-click-outside="hideNotificationList"
                  :class="{
                    rotateBell: have_notifcation,
                  }"
                />
              </div>
              <div class="have-notification shake" v-if="have_notifcation">
                <span v-if="notifications.length > 9"> +9</span>
                <span v-else>{{ notifications.length }}</span>
              </div>
              <div
                class="notification-list"
                v-if="notifications && notifications.length && show_notifcation_list"
              >
                <div v-if="notifications?.length">
                  <div
                    v-for="(notification, index) in notifications"
                    :key="index"
                    class="driver-block"
                    @click="openNotifcation(notification)"
                  >
                    <div
                      class="d-flex align-item-center"
                      v-if="notification?.type === 'messagingCenter'"
                    >
                      <div class="driver-avtar">
                        <img
                          class="driver_profilePicture"
                          v-if="notification?.driver?.picture"
                          :src="notification?.driver?.picture"
                        />
                        <img v-else src="@/assets/images/icons/user-icon.svg" />
                      </div>
                      <div class="driver-info">
                        <div class="d-flex align-item-center mb-1">
                          <div class="driver-name">
                            {{
                              isLangRtl
                                ? notification?.driver?.arabicName
                                : notification?.driver?.name
                            }}
                          </div>
                        </div>
                        <div class="driver-msg" v-if="notification?.message">
                          <div
                            class="d-flex align-items-center"
                            v-if="photo?.includes(notification.message.split('.').pop())"
                          >
                            <img src="@/assets/images/icons/photo-camera.png" alt="photo-camera" />
                            <div class="mx-1">
                              {{ $t('photo') }}
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center"
                            v-else-if="video?.includes(notification.message.split('.').pop())"
                          >
                            <img src="@/assets/images/icons/video-camera.png" alt="video-camera" />
                            <div class="mx-1">
                              {{ $t('video') }}
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center"
                            v-else-if="audio?.includes(notification.message.split('.').pop())"
                          >
                            <img
                              src="@/assets/images/icons/speaker-filled-audio-tool.png"
                              alt="speaker-filled-audio-tool"
                            />
                            <div class="mx-1">
                              {{ $t('audio') }}
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center"
                            v-else-if="document?.includes(notification.message.split('.').pop())"
                          >
                            <img src="@/assets/images/icons/google-docs.png" alt="google-docs" />
                            <div class="mx-1">
                              {{ $t('document') }}
                            </div>
                          </div>
                          <div v-else>
                            {{ notification?.message.substring(0, 28)
                            }}{{ notification?.message.length > 28 ? '....' : '' }}
                          </div>
                          <div v-if="isSameDay(notification?.created_on)">
                            {{ notification?.created_on | moment('h:mm a') }}
                          </div>
                          <div v-else-if="isYesterday(notification?.created_on)">
                            {{ $t('yesterday') }}
                          </div>
                          <div v-else-if="isSameWeek(notification?.created_on)">
                            {{ notification?.created_on | moment('dddd') }}
                          </div>
                          <div v-else>
                            {{ notification?.created_on | moment('DD-MM-YYYY') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex align-item-center"
                      v-if="notification?.type === 'timeOffRequest'"
                    >
                      <div class="driver-avtar">
                        <img
                          class="driver_profilePicture"
                          v-if="notification?.requestedBy?.profilePicture"
                          :src="notification?.requestedBy?.profilePicture"
                        />
                        <img v-else src="@/assets/images/icons/user-icon.svg" />
                      </div>
                      <div class="driver-info d-flex flex-column justify-content-center">
                        <div class="d-flex align-item-center mb-1">
                          <div class="driver-name">
                            {{
                              isLangRtl
                                ? notification?.requestedBy?.arabicName
                                : notification?.requestedBy?.name
                            }}
                          </div>
                        </div>
                        <div class="driver-msg">
                          <div>
                            {{
                              notification?.type === 'timeOffRequest'
                                ? $t('time-off-request')
                                : notification?.type
                            }}
                          </div>
                          <div v-if="isSameDay(notification?.created_on)">
                            {{ formatTime(notification?.created_on) }}
                          </div>
                          <div v-else-if="isYesterday(notification?.created_on)">
                            {{ $t('yesterday') }}
                          </div>
                          <div v-else-if="isSameWeek(notification?.created_on)">
                            {{ notification?.created_on | moment('dddd') }}
                          </div>
                          <div v-else>
                            {{ notification?.created_on | moment('DD-MM-YYYY') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="notification?.type === 'resourceRequest'">
                      <div class="driver-info">
                        <div class="d-flex align-item-center mb-1">
                          <div class="driver-name" v-if="notification?.requestedBy">
                            {{ notification?.requestedBy }}
                          </div>
                          <div class="driver-name" v-else-if="notification?.updated_by">
                            {{ notification?.updated_by }}
                          </div>
                        </div>
                        <div class="driver-msg">
                          <div v-if="notification?.status?.toLocaleLowerCase() === 'pending'">
                            {{ $t('created-new-resource-request') }}
                          </div>
                          <div v-else-if="notification?.status?.toLocaleLowerCase() === 'approved'">
                            {{ $t('approved-resource-request') }}
                          </div>
                          <div v-else-if="notification?.status?.toLocaleLowerCase() === 'rejected'">
                            {{ $t('rejected-resource-request') }}
                          </div>
                          <div v-if="isSameDay(notification?.updated_on)">
                            {{ notification?.updated_on | moment('h:mm a') }}
                          </div>
                          <div v-else-if="isYesterday(notification?.updated_on)">
                            {{ $t('yesterday') }}
                          </div>
                          <div v-else-if="isSameWeek(notification?.updated_on)">
                            {{ notification?.updated_on | moment('dddd') }}
                          </div>
                          <div v-else>
                            {{ notification?.updated_on | moment('DD-MM-YYYY') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="notification?.type === 'reservationRequest'">
                      <div class="driver-info">
                        <div class="d-flex align-item-center mb-1">
                          <div class="driver-name" v-if="notification?.requestedBy">
                            {{ notification?.requestedBy?.name }}
                          </div>
                          <div class="driver-name" v-else-if="notification?.updated_by">
                            {{ notification?.updated_by }}
                          </div>
                        </div>
                        <div class="driver-msg">
                          <div v-if="notification.requestedBy">
                            {{ $t('created-new-reservation-request') }}
                          </div>
                          <div v-else-if="notification?.status?.toLocaleLowerCase() === 'approved'">
                            {{ $t('approved-reservation-request') }}
                          </div>
                          <div v-else-if="notification?.status?.toLocaleLowerCase() === 'rejected'">
                            {{ $t('rejected-reservation-request') }}
                          </div>
                          <div v-if="isSameDay(notification?.created_on)">
                            {{ notification?.created_on | moment('h:mm a') }}
                          </div>
                          <div v-else-if="isYesterday(notification?.created_on)">
                            {{ $t('yesterday') }}
                          </div>
                          <div v-else-if="isSameWeek(notification?.created_on)">
                            {{ notification?.created_on | moment('dddd') }}
                          </div>
                          <div v-else>
                            {{ notification?.created_on | moment('DD-MM-YYYY') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="notification?.type === 'driverAllowanceRequest'">
                      <div class="driver-info">
                        <div class="d-flex align-item-center mb-1">
                          <div
                            class="driver-name"
                            v-if="notification.actionType.toLocaleLowerCase() === 'pending'"
                          >
                            {{ notification?.created_by }}
                          </div>
                          <div class="driver-name" v-else>
                            {{ notification?.actionBy }}
                          </div>
                        </div>
                        <div class="driver-msg">
                          <div v-if="notification.actionType.toLocaleLowerCase() === 'approved'">
                            {{ $t('approved-allowance-request', { id: notification?._id }) }}
                          </div>
                          <div
                            v-else-if="notification.actionType.toLocaleLowerCase() === 'rejected'"
                          >
                            {{ $t('rejected-allowance-request', { id: notification?._id }) }}
                          </div>
                          <div v-else>
                            {{ $t('created-new-allowance-request') }}
                          </div>
                          <div v-if="isSameDay(notification?.created_on)">
                            {{ notification?.created_on | moment('h:mm a') }}
                          </div>
                          <div v-else-if="isYesterday(notification?.created_on)">
                            {{ $t('yesterday') }}
                          </div>
                          <div v-else-if="isSameWeek(notification?.created_on)">
                            {{ notification?.created_on | moment('dddd') }}
                          </div>
                          <div v-else>
                            {{ notification?.created_on | moment('DD-MM-YYYY') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="notification?.type === 'tripExceedDistance'">
                      <div class="driver-info">
                        <div class="d-flex align-item-center mb-1">
                          <div class="driver-name" v-if="notification?.title">
                            {{ notification?.title }}
                          </div>
                        </div>
                        <div class="driver-msg">
                          <div>
                            {{ $t('exceeding-the-maximum-allowed-distance') }}
                          </div>
                          <div v-if="isSameDay(notification?.created_on)">
                            {{ notification?.created_on | moment('h:mm a') }}
                          </div>
                          <div v-else-if="isYesterday(notification?.created_on)">
                            {{ $t('yesterday') }}
                          </div>
                          <div v-else-if="isSameWeek(notification?.created_on)">
                            {{ notification?.created_on | moment('dddd') }}
                          </div>
                          <div v-else>
                            {{ notification?.created_on | moment('DD-MM-YYYY') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="notification?.type === 'escalationNotification'">
                      <div
                        class="escalation-notification"
                        @click="moveToWorkflowRequest(notification)"
                        v-if="!notification?.isEscalatedNotification"
                      >
                        <div class="notification-content">
                          <div class="notification-title">
                            {{ $t('workflow-new-task-assignment') }}
                          </div>
                          <div class="notification-metadata">
                            <span class="task-id">
                              {{ $t('workflow-task-id') }} : #
                              {{ notification?.workflowInstanceID }}
                            </span>
                          </div>
                          <div class="notification-description">
                            {{ assignmentMessage(notification) }}
                          </div>
                        </div>
                        <div class="notification-actions">
                          <button
                            class="view-details-btn"
                            @click.stop="moveToWorkflowRequest(notification)"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
                                fill="currentColor"
                              />
                            </svg>
                            {{ $t('view-details') }}
                          </button>
                        </div>
                      </div>
                      <div
                        class="escalation-notification"
                        @click="moveToWorkflowRequest(notification)"
                        v-else-if="notification?.isEscalatedNotification"
                      >
                        <div class="notification-content">
                          <div class="notification-title">
                            {{ $t('workflow-escalation-notification-title') }}
                          </div>
                          <div class="notification-metadata">
                            <span class="task-id">
                              {{ $t('workflow-task-id') }} : #
                              {{ notification?.workflowInstanceID }}
                            </span>
                          </div>
                          <div class="notification-description">
                            {{ escalationMessage(notification) }}
                          </div>
                        </div>
                        <div class="notification-actions">
                          <button
                            class="view-details-btn"
                            @click.stop="moveToWorkflowRequest(notification)"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
                                fill="currentColor"
                              />
                            </svg>
                            {{ $t('view-details') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="show_notifcation_list" class="notification-list">
                <div class="driver-block text-center">
                  {{ $t('no-new-notification') }}
                </div>
              </div>
            </div>
            <div style="position: relative">
              <img
                class="mx-2"
                v-if="notMobile"
                @click.stop="toggleMenu"
                :src="require(`@/assets/images/universal.svg`)"
                alt="settings"
                width="32"
              />
              <div v-if="isMenuOpen" v-click-outside="toggleMenu" class="menu-lang text-center">
                <div class="link-menu-option" @click="switchLanguage('en')">En</div>
                <div class="link-menu-option" @click="switchLanguage('ar')">Ar</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </header>
  </div>
</template>
<script>
import moment from 'moment'
import { state } from '@/socket'
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
  },
  props: ['notMobile'],
  data() {
    return {
      isMenuOpen: false,
      show_notifcation_list: false,
      have_notifcation: false,
      notifications: [],
      photo: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff'],
      video: ['webm', 'mp4', 'ogg'],
      audio: ['mp3', 'ogg', 'm4a'],
      document: ['doc', 'docx', 'pdf'],
      cachedBreadcrumbItems: [],
    }
  },
  computed: {
    breadcrumbItems() {
      return this.cachedBreadcrumbItems
    },
    operator_support_chat_update() {
      return state.operator_support_chat_update
    },
    time_off_request_update() {
      return state.time_off_request_update
    },
    operator_branch_request_update() {
      return state.operator_branch_request_update
    },
    reservation_request_update() {
      return state.reservation_request_update
    },
    trip_exceed_distance() {
      return state.trip_exceed_distance
    },
    driver_allowance_request_update() {
      return state.driver_allowance_request_update
    },
    showBackButton() {
      const currentRoute = this.$route.path
      return !(
        currentRoute === '/' ||
        currentRoute === '' ||
        currentRoute.startsWith('/dashboard/')
      )
    },
    escalationNotificationUpdate() {
      return state.escalationNotification
    },
  },
  watch: {
    operator_support_chat_update(val) {
      if (val?.driver?._id) {
        this.have_notifcation = true
        this.notifications.unshift({ ...val, ...{ type: 'messagingCenter' } })
      }
    },
    time_off_request_update(val) {
      if (val?._id) {
        this.have_notifcation = true
        this.notifications.unshift({
          ...val,
          ...{ type: 'timeOffRequest' },
        })
      }
    },
    operator_branch_request_update(val) {
      if (val?._id) {
        this.have_notifcation = true
        this.notifications.unshift({
          ...val,
          ...{ type: 'resourceRequest' },
        })
      }
    },
    reservation_request_update(val) {
      if (val?._id) {
        this.have_notifcation = true
        this.notifications.unshift({
          ...val,
          ...{ type: 'reservationRequest' },
        })
      }
    },
    trip_exceed_distance(val) {
      if (val) {
        this.have_notifcation = true
        this.notifications.unshift({
          ...val,
          ...{ type: 'tripExceedDistance' },
        })
      }
    },
    driver_allowance_request_update(val) {
      if (val) {
        this.have_notifcation = true
        this.notifications.unshift({
          ...val,
          ...{ type: 'driverAllowanceRequest' },
        })
      }
    },
    $route: {
      handler() {
        this.generateBreadcrumbItems()
      },
      immediate: true,
    },
    escalationNotificationUpdate(val) {
      if (val?.workflowInstanceID) {
        this.have_notifcation = true
        this.notifications.unshift({
          ...val,
          ...{ type: 'escalationNotification' },
        })
      }
    },
  },
  methods: {
    formatTime(time) {
      return moment(time)
        .locale(this.isLangRtl ? 'ar' : 'en')
        .format('h:mm a')
    },
    goBack(breadcrumbItems) {
      if (
        breadcrumbItems[0]?.customGoBack &&
        breadcrumbItems[0]?.to?.path === '/operations/list' &&
        this.$route?.query?.clientID
      ) {
        this.$router.push(`/client/${this.$route?.query?.clientID}`).catch(() => {})
      } else {
        this.$router.go(-1)
      }
    },
    switchLanguage(language) {
      localStorage.setItem('lang', language)
      window.location.reload()
      // window.history.replaceState({}, "", `?lang=${language}`);
    },
    toggleMenu() {
      this.show_notifcation_list = false
      this.isMenuOpen = !this.isMenuOpen
    },
    openNotifcation(data) {
      switch (data.type) {
        case 'messagingCenter': {
          if (data?.driver?._id) {
            this.notifications = this.notifications.filter(
              (each) => each?.type === 'messagingCenter' && each?.driver?._id !== data?.driver?._id
            )
            const url = `/messaging-center?driverId=${data?.driver?._id}`
            if (this.$route.fullPath !== url) this.$router.push(url).catch(() => {})
          }
          break
        }
        case 'timeOffRequest': {
          this.notifications = this.notifications.filter(
            (each) => each?.type === 'timeOffRequest' && each?._id !== data?._id
          )
          const url = `/time-off-requests?requestId=${data?._id}`
          if (this.$route.fullPath !== url) {
            this.$router.push(url).catch(() => {})
          }
          break
        }
        case 'resourceRequest': {
          this.notifications = this.notifications.filter(
            (each) => each?.type === 'resourceRequest' && each?._id !== data?._id
          )

          let url
          if (data?.status?.toLocaleLowerCase() === 'pending')
            url = `/resource-requests?id=${data?._id}&status=${data?.status}`
          else url = `/my-requests?id=${data?._id}`

          if (this.$route.fullPath !== url) this.$router.push(url).catch(() => {})
          break
        }
        case 'reservationRequest': {
          this.notifications = this.notifications.filter(
            (each) => each?.type === 'reservationRequest' && each?._id !== data?._id
          )

          let url
          if (
            data?.status?.toLocaleLowerCase() === 'rejected' ||
            data?.status?.toLocaleLowerCase() === 'approved'
          ) {
            url = `/my-requests?id=${data?._id}&tab=reservations-tab`
          } else {
            if (!this.$store.getters['enums/is_not_permitted']('approveRejectReservationRequest')) {
              url = `/reservations-requests?id=${data?._id}&status=${data?.status || 'pending'}`
            } else {
              url = `/my-requests?id=${data?._id}&tab=reservations-tab`
            }
          }

          if (
            !this.$store.getters['enums/is_not_permitted']('viewReservationRequest') &&
            this.$route.fullPath !== url
          )
            this.$router.push(url).catch(() => {})
          break
        }
        case 'driverAllowanceRequest': {
          this.notifications = this.notifications.filter(
            (each) => each?.type === 'driverAllowanceRequest' && each?._id !== data?._id
          )
          let url
          if (
            data?.actionType?.toLocaleLowerCase() === 'rejected' ||
            data?.actionType?.toLocaleLowerCase() === 'approved'
          ) {
            url = `/allowance-requests?id=${
              data?._id
            }&status=${data?.actionType?.toLocaleLowerCase()}`
          } else {
            url = `/allowance-requests?id=${data?._id}&status=pending`
          }
          if (
            !this.$store.getters['enums/is_not_permitted']('viewDriverAllowance') &&
            this.$route.fullPath !== url
          )
            this.$router.push(url).catch(() => {})
          break
        }
        case 'tripExceedDistance': {
          this.notifications = this.notifications.filter(
            (each) =>
              each?.type === 'tripExceedDistance' &&
              each?.vehicle !== data?.vehicle &&
              each?.driver !== data?.driver &&
              each?.trip !== data?.trip
          )

          const url = `/dashboard/map?driver=${data?.driver}&vehicle=${data?.vehicle}&trip=${data?.trip}`

          if (
            !this.$store.getters['enums/is_not_permitted']('dashboardTab') &&
            this.$route.fullPath !== url
          )
            this.$router.push(url).catch(() => {})
          break
        }
      }
      this.toggleShowNotificationList()
    },
    toggleShowNotificationList() {
      this.have_notifcation = false
      this.show_notifcation_list = !this.show_notifcation_list
      this.isMenuOpen = false
    },
    hideNotificationList() {
      this.show_notifcation_list = false
    },
    isSameDay(date) {
      return moment(new Date(date).toISOString().substring(0, 10)).isSame(
        new Date().toISOString().substring(0, 10)
      )
    },
    isYesterday(date) {
      const yesterday = moment().clone().subtract(1, 'days').startOf('day')
      return moment(date).isSame(yesterday, 'd')
    },
    isSameWeek(date) {
      return moment(date).isSame(moment(), 'week')
    },
    generateBreadcrumbItems() {
      const route = this.$route
      const routes = route.matched
      const items = []
      let path = ''

      for (let i = 0; i < routes.length; i++) {
        const r = routes[i]
        if (r.meta && r.meta.breadcrumb) {
          for (let j = 0; j < r.meta.breadcrumb.length; j++) {
            const b = { ...r.meta.breadcrumb[j] } // Create a copy
            const to = {}

            if (typeof b.to === 'string') {
              if (b.to?.includes(':id')) {
                to.path = b.to?.replace(/:id/g, this.$route.params?.id)
              } else {
                to.path = b.to
              }
            } else if (typeof b.to === 'object') {
              to.path = b.to.path || this.$router.resolve(b.to).href
            }

            if (i === routes.length - 1) {
              path += r.path
            } else {
              path += r.path === '/' ? '' : r.path
            }

            let displayText = b.text

            if (b.text.includes('LTA#')) {
              displayText = `${this.$t('lta')}#${route?.params?.id}`
            }
            if (b.text.includes('Client#')) {
              displayText = `${this.$t('client')}#${route?.params?.id}`
            }
            if (b.text.includes('Contract#')) {
              displayText = `${this.$t('contract')}#${route?.params?.id}`
            }
            if (b.text.includes('Routes#')) {
              displayText = `${this.$t('route')}#${route?.params?.routeId}`
            }
            if (b.text === 'manage-trips' && this.$route?.query?.clientID) {
              displayText = `${this.$t('trips')}`
            }

            items.push({
              text: this.$t(displayText),
              to,
              disabled: b.disabled,
              active: b.active,
              customGoBack: b.customGoBack,
            })
          }
        }
      }

      this.cachedBreadcrumbItems = items
      return items
    },
    moveToWorkflowRequest(item) {
      this.navigateTo(`/workflow-request/${item.workflowInstanceID}`)
    },
    escalationMessage(notification) {
      const days = notification?.numberOfDaysForEscalation
      const hours = notification?.numberOfHoursForEscalation
      const taskId = notification.workflowInstanceID
      let message = this.$t('workflow-task-escalation-notification', { taskId })

      if (days > 0) {
        message = ` ${this.$t('workflow-task-escalation-days', { taskId, days })}`
      }
      if (hours > 0) {
        message = ` ${this.$t('workflow-task-escalation-hours', { taskId, hours })}`
      }
      if (days > 0 && hours > 0) {
        message = ` ${this.$t('workflow-task-escalation-days-hours', { taskId, days, hours })}`
      }

      return message
    },
    assignmentMessage(notification) {
      const taskId = notification.workflowInstanceID
      const withEscalation = notification?.withEscalation
      let message = this.$t('workflow-assign-new-task', { taskId })
      if (withEscalation) {
        const days = notification?.numberOfDaysForEscalation
        const hours = notification?.numberOfHoursForEscalation
        if (days > 0) {
          message = ` ${this.$t('workflow-task-assignment-days', { taskId, days })}`
        }
        if (hours > 0) {
          message = ` ${this.$t('workflow-task-assignment-hours', { taskId, hours })}`
        }
        if (days > 0 && hours > 0) {
          message = ` ${this.$t('workflow-task-assignment-days-hours', { taskId, days, hours })}`
        }
      }
      return message
    },
  },
  mounted() {
    this.generateBreadcrumbItems()
  },
}
</script>

<style lang="scss" scoped>
.header__container {
  align-items: center;
  width: 100%;
  gap: 18px;
  img {
    cursor: pointer;
  }
  .hide_go_back {
    visibility: hidden;
  }
  .bell-icon {
    height: 2rem;
    width: 2rem;
    border-radius: 0.375rem;
    background-color: var(--color-142);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.small-size {
  padding-left: 1rem !important;
}
.small-size .breadcrumb-item {
  font-weight: bold;
  font-size: 20px;
}
.breadcrumb-item {
  font-weight: bold;
  font-size: 24px;
  white-space: nowrap;
}
.menu-lang {
  z-index: 9999;
  position: absolute;
  top: 50px;
  inset-inline-end: 0px;
  width: 100px;
  padding: 12px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-15);
  background: var(--color-01);

  .link-menu-option {
    cursor: pointer;
    color: var(--color-26);
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    padding: 0.5rem 0rem;
    &:not(:last-child) {
      border-bottom: 1px solid var(--color-15);
    }
  }
}

.have-notification {
  position: absolute;
  top: -10px;
  right: -4px;
  padding: 6px;
  height: 18px;
  width: 18px;
  background-color: red;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: var(--color-01);
    font-size: 10px;
    font-weight: 700;
  }
}

.notification-list {
  position: absolute;
  top: 50px;
  inset-inline-end: 0px;
  width: 320px;
  background: var(--color-01);
  border: 1px solid var(--color-23);
  font-size: 14px;
  max-height: 250px;
  overflow: auto;
  z-index: 9999;

  .driver-block,
  .request-block {
    cursor: pointer;
    padding: 1rem;

    &:hover {
      background: var(--color-73);
    }

    &.active {
      background: var(--color-73);
    }

    .driver-avtar {
      position: relative;
      height: 3rem;
      width: 3rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--color-13);
      border: 1px solid var(--color-70);
      .driver_profilePicture {
        height: 3rem;
        width: 3rem;
        border-radius: 50%;
      }
    }
    .driver-info {
      margin-inline-start: 0.5rem;
      flex: 1 1 auto;
      .driver-name {
        flex: 1 1 auto;
        color: var(--color-68);
        font-size: 0.875rem;
        font-weight: 700;
      }

      .driver-msg {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.75rem;
        color: var(--color-69);
      }
    }
    .border-container {
      height: 1px;
      width: 100%;
      background-color: var(--color-70);
    }
  }
}

.notification-list::-webkit-scrollbar {
  width: 5px;
}

.notification-list::-webkit-scrollbar-track {
  background: var(--color-44);
}

.notification-list::-webkit-scrollbar-thumb {
  background: var(--color-23);
}

.notification-list::-webkit-scrollbar-thumb:hover {
  background: var(--color-45);
}

@keyframes shake {
  0%,
  100% {
    transform: translateY(0);
  }
  20%,
  60% {
    transform: translateY(2px);
  }
  40%,
  80% {
    transform: translateY(-2px);
  }
}

.shake {
  animation: shake 0.7s ease-in-out infinite;
}
@keyframes rotateBell {
  0%,
  100% {
    transform: rotate(0);
  }
  20%,
  60% {
    transform: rotate(-35deg);
  }
  40%,
  80% {
    transform: rotate(35deg);
  }
}

.rotateBell {
  animation: rotateBell 0.9s ease-in-out infinite;
}

.notification-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.notification-icon {
  width: 24px;
  height: 24px;
  margin-right: 0.5rem;
}

.notification-badge {
  background-color: var(--color-84);
  border-radius: 12px;
  padding: 0.125rem 0.5rem;
  font-size: 0.625rem;
  font-weight: 700;
  color: var(--color-01);
}

.notification-content {
  .notification-title {
    font-weight: 700;
    color: var(--color-68);
    margin-bottom: 0.25rem;
  }

  .notification-description {
    color: var(--color-69);
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  .notification-metadata {
    display: flex;
    justify-content: space-between;
    font-size: 0.75rem;
    color: var(--color-69);

    .task-id {
      font-weight: 700;
    }

    .timestamp {
      color: var(--color-69);
    }
  }
}

.notification-actions {
  display: flex;
  justify-content: flex-end;

  .view-details-btn {
    background-color: var(--color-84);
    color: var(--color-01);
    border: none;
    border-radius: 4px;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
      margin-right: 0.25rem;
    }

    &:hover {
      background-color: var(--color-73);
    }
  }
}

.escalation-notification {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  .notification-content {
    margin-bottom: 16px;

    .notification-title {
      color: var(--color-68);
      font-size: 1rem;
      font-weight: 700;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    .notification-description {
      font-size: 0.875rem;
      color: var(--color-69);
      line-height: 1.5;
      margin-bottom: 12px;
    }

    .notification-metadata {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 8px !important;
      .task-id {
        background: var(--color-10);
        color: var(--color-02);
        padding: 4px 4px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }

  .notification-actions {
    display: flex;
    justify-content: flex-end;

    .view-details-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      background: linear-gradient(135deg, var(--color-23) 0%, #007a85 100%);
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);

      &:hover {
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
      }

      svg {
        transition: transform 0.3s ease;
      }

      &:hover svg {
        transform: scale(1.1);
      }
    }
  }
}

// Mobile responsive
@media (max-width: 768px) {
  .escalation-notification {
    padding: 12px;
    margin: 4px 0;

    .notification-header {
      .notification-icon {
        width: 36px;
        height: 36px;
      }
    }

    .notification-content {
      .notification-title {
        font-size: 14px;
      }

      .notification-description {
        font-size: 13px;
      }

      .notification-metadata {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }
    }

    .notification-actions {
      .view-details-btn {
        padding: 6px 12px;
        font-size: 12px;
      }
    }
  }
}
</style>
